import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/pages/Landing.vue';

const fullRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  // },
  // {
  //   path: '/ui-kit',
  //   name: 'uikit',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/pages/UiKit.vue'),
  // },
];

const comingSoonRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'coming-soon',
    component: () => import(/* webpackChunkName: "coming_soon" */ '../views/pages/ComingSoon.vue'),
  },
];

let routes = [];
if (process.env.VUE_APP_ACTIVATE_COMING_SOON === 'true') {
  routes = [...comingSoonRoutes];
} else {
  routes = [...fullRoutes];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
